export const REGIONS = 'REGIONS'

export const ERROR_STATE = 'ERROR_STATE'
